import {Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'dateAgo',
    pure: false
})

export class DateAgoPipe implements PipeTransform {
    constructor(private translationService: TranslateService) {

    }
    transform(value: any, args?: any): any {
        if (value) {
            const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
            if (seconds < 59) {
                return this.translationService.instant(`generic.timeComponents.justNow`);
            }

            return this.computeValues(value);
        }
        return value;
    }

    translateKeySingle(key: string) {
        return this.translationService.instant(`generic.timeComponents.${key}`);
    }

    translateKeyMultiple(key: string) {
        return this.translationService.instant(`generic.timeComponents.${key}s`);
    }

    computeValues(startValue: any): string {
        const startTime = new Date(startValue);
        const endTime = new Date();

        let timeDiff = +endTime - +startTime;

        // strip the ms
        timeDiff /= 1000;

        const seconds = Math.round(timeDiff % 60);

        // remove seconds from the date
        timeDiff = Math.floor(timeDiff / 60);

        // get minutes
        const minutes = Math.round(timeDiff % 60);

        // remove minutes from the date
        timeDiff = Math.floor(timeDiff / 60);

        // get hours
        const hours = Math.round(timeDiff % 24);

        // remove hours from the date
        timeDiff = Math.floor(timeDiff / 24);

        let days = timeDiff;
        let weeks = 0;
        if (timeDiff > 7) {
            days = Math.floor(timeDiff % 7);
            weeks = Math.floor(timeDiff / 7);
        }

        let displayString = '';
        if (weeks >= 1) {
            displayString = weeks.toString().concat(" ", this.translateKeySingle("week"), " ");
        }

        if (days >= 1) {
            displayString = displayString.length > 0
                    ? displayString.concat(" ", days.toString(), " ", this.translateKeySingle("day"), " ")
                    : days.toString().concat(" ", this.translateKeySingle("day"), " ");
        }

        if (hours >= 1) {
            displayString = displayString.length > 0
                ? displayString.concat(" ", hours.toString(), " ", this.translateKeySingle("hour"), " ")
                : hours.toString().concat(" ", this.translateKeySingle("hour"), " ");
        }

        if (minutes >= 1) {
            displayString = displayString.length > 0
                ? displayString.concat(" ", minutes.toString(), " ", this.translateKeySingle("minute"), " ")
                : minutes.toString().concat(" ", this.translateKeySingle("minute"), " ");
        }

        return displayString;
    }
}

